export default {
  BT_O: "ဂိုးပေါ်",
  BT_U: "ဂိုးအောက်",

  BT_BOTH: "နှစ်ဖက်စလုံး",
  BT_ONE: "တစ်",
  BT_HDP: "ပေါက်ကြေး",
  BT_OU: "ဂိုးပေါ် / ဂိုးအောက်",
  BT_ML: "Moneyline",
  BT_1X2: "အနိုင်အရှုံးသရေ",
  BT_1X2HDP: "၃မျိုးပေါက်‌ကြေး",
  BT_CS: "ဂိုးခန့်မှန်း",
  BT_OE: "မ/စုံ",
  BT_DC: "နှစ်ထပ်အခွင့်အရေး",
  BT_HTFT: "ပထမပိုင်း / ပွဲချိန်ပြည့်",
  BT_FGLG: "ပထမဂိုး / နောက်ဆုံးဂိုး",
  BT_TG: "ဂိုးအရေအတွက်",
  BT_OR: "ဖလားခန့်မှန်း",
  BT_ORZ: "ဖလားခန့်မှန်း",
  BT_ODD: "မျိုး",
  BT_EVEN: "တစ်မျိုး",

  BT_ANB: "အ‌ဝေးကွင်းလောင်း၍မရပါ",
  BT_BS: "နှစ်သင်း ၊ တစ်သင်း ၊ နှစ်သင်းလုံးဂိုးမသွင်းပါ",
  BT_CL: "ပေးဂိုးမရှိ",
  BT_DNB: "သရေလောင်း၍မရပါ",
  BT_DNBH: "ပထမပိုင်း သရေလောင်း၍မရပါ",
  BT_HNB: "အိမ်ကွင်းလောင်း၍မရပါ",
  BT_TWTN: "ပေးဂိုးမရှိပဲ အနိုင်ရရှိသူ",

  BT_HDPH: "ပထမပိုင်းပေါက်ကြေး",
  BT_OUH: "ပထမပိုင်း ဂိုး‌ပေါင်း",
  BT_MLH: "ပထမပိုင်းအနိုင်",
  BT_1X2H: "ပထမပိုင်း အနိုင် ၊ အရှုံး ၊ သရေ",
  BT_1X2HDPH: "ပထမပိုင်း အနိုင် ၊ အရှုံး ၊ သရေ",
  BT_CSH: "ပထမပိုင်း ဂိုးခန့်မှန်း",
  BT_OEH: "ပထမပိုင်း မ/စုံ",
  BT_DCH: "ပထမပိုင်း နှစ်ထပ်အခွင့်အရေး",
  BT_FGLGH: "ပထမပိုင်း ပထမဂိုး / နောက်ဆုံးဂိုး",
  BT_TGH: "ပထမပိုင်း ဂိုးအရေအတွက်",

  TB_HDP: "ပွဲချိန်ပြည့် ပေါက်ကြေး",
  TB_OU: "ပွဲချိန်ပြည့် ဂိုးပေါင်း",
  TB_1X2: "ပွဲချိန်ပြည့် အနိုင် ၊ အရှုံး ၊ သရေ",
  TB_OE: "ပွဲချိန်ပြည့် မ/စုံ",
  TB_HDPH: "ပထမပိုင်း ပေါက်ကြေး",
  TB_OUH: "ပထမပိုင်း ဂိုးပေါင်း",
  TB_1X2H: "ပထမပိုင်း အနိုင်၊ အရှုံး ၊ သရေ",
  TB_OEH: "ပထမပိုင်း မ/စုံ",

  BT_HDPOU: "‌ပေါက်ကြေး & ဂိုးပေါင်း",
  BT_PARLAY: "မောင်းကစားနည်း",
  BT_FT: "ပွဲချိန်ပြည့်",
  BT_1H: "ပထမပိုင်း. ",
  BT_2H: "ဒုတိယပိုင်း. ",

  BT_FG: "ပထမသွင်းဂိုး",
  BT_LG: "နောက်ဆုံးသွင်းဂိုး",
  BT_HFG: "ပထမသွင်းဂိုး (အိမ်ရှင်)",
  BT_AFG: "ပထမသွင်းဂိုး (အ‌ဝေး)",
  BT_HLG: "နောက်ဆုံးသွင်းဂိုး (အိမ်ရှင်)",
  BT_ALG: "နောက်ဆုံးသွင်းဂိုး (အဝေး)",
  BT_NG: "ဂိုးမသွင်း",
  BT_HY: "အိမ်ရှင် Yes",
  BT_HN: "အိမ်ရှင် No",
  BT_AY: "အဝေး Yes",
  BT_AN: "အဝေး No",
  BT_H: "အိမ်ရှင်",
  BT_A: "အဝေး",
  BT_D: "သရေ",
  BT_HD_DC: "အိမ်ရှင် & သရေ",
  BT_HA_DC: "အိမ်ရှင် & အဝေး",
  BT_DA_DC: "အဝေး & သရေ",
  BT_HH: "အိမ်ရှင် ၊ အိမ်ရှင်",
  BT_HD: "အိမ်ရှင် ၊ သရေ",
  BT_HA: "အိမ်ရှင် ၊ အဝေး",
  BT_DH: "သရေ ၊ အိမ်ရှင် ",
  BT_DD: "သရေ ၊ သရေ",
  BT_DA: "သရေ ၊ အဝေး",
  BT_AH: "အ‌ဝေး ၊ အိမ်ရှင် ",
  BT_AD: "အဝေး ၊ သရေ",
  BT_AA: "အဝေး ၊ အဝေး ",

  BT_Y: "Yes",
  BT_N: "No",

  BT_LIVE: "တိုက်ရိုက်",
  BT_HT: "ပထမပိုင်း ",
  BT_DELAYED: "နောက်ကျနေသည်",
  BT_PEN: "ပင်နယ်တီ",

  BT_FT1: "ပွဲချိန်ပြည့် 1 ",
  BT_FT2: "ပွဲချိန်ပြည့် 2",
  BT_FTX: "ပွဲချိန်ပြည့် x",

  TC_FT1: "1",
  TC_FT2: "2",
  TC_FTX: "X",

  BT_HT1: "ပထမပိုင်း 1",
  BT_HT2: "ပထမပိုင်း 2",
  BT_HTX: "ပထမပိုင်း x",

  F5_INN_HDP: "F5 INN. HDP",
  F5_INN_OU: "F5 INN. O/U",

  BS_HDP: "ပွဲချိန်ပြည့်ပေါက်ကြေး",
  BS_HDPH: "ပထမပိုင်း ပေါက်ကြေး",
  BS_OU: "ပွဲချိန်ပြည့် ဂိုးပေါင်း",
  BS_OUH: "ပထမပိုင်း ဂိုးပေါင်း",
  BS_OE: "ပွဲချိန်ပြည့် မ/စုံ",
  BS_OEH: "ပထမပိုင်း မ/စုံ",
  BS_1X2: "ပွဲချိန်ပြည့် 1x2",
  BS_1X2H: "ပထမပိုင်း 1x2",
  BS_ML: "ပွဲချိန်ပြည့် Moneyline",
  BS_MLH: "ပထမပိုင်း Moneyline",
  BS_1X2HDP: "ပွဲချိန်ပြည့် ၃ မျိုးပေါက်‌ကြေး",
  BS_1X2HDPH: "ပထမပိုင်း ၃ မျိုးပေါက်ကြေး",
  BS_CS: "ပွဲချိန်ပြည့် ဂိုးခန့်မှန်း",
  BS_CSH: "ပထမပိုင်း ဂိုးခန့်မှန်း",
  BS_DC: "ပွဲချိန်ပြည့် နှစ်ထပ်အခွင့်အရေး",
  BS_DCH: "ပထမပိုင်း နှစ်ထပ်အခွင့်အရေး",
  BS_FGLG: "ပွဲချိန်ပြည့် ပထမဂိုး / နောက်ဆုံးဂိုး",
  BS_FGLGH: "ပထမပိုင်း ပထမဂိုး / နောက်ဆုံးဂိုး",
  BS_TG: "ပွဲချိန်ပြည့် ဂိုးအရေအတွက်",
  BS_TGH: "ပထမပိုင်း ဂိုးအရေအတွက်",
  BS_ANB: "အဝေးကွင်း လောင်း၍မရပါ",
  BS_HTFT: "ပထမပိုင်း / ပွဲချိန်ပြည့်",
  BS_BS: "နှစ်သင်း ၊ တစ်သင်း ၊ နှစ်သင်းလုံးဂိုးမသွင်းပါ",
  BS_CL: "ပေးဂိုးမရှိ",
  BS_DNB: "သရေလောင်း၍မရပါ",
  BS_DNBH: "ပထမပိုင်း သရေလောင်း၍မရပါ",
  BS_HNB: "အိမ်ကွင်းလောင်း၍မရပါ",
  BS_TWTN: "ပေးဂိုးမရှိအနိုင်",
  BS_OR: "ဖလားခန့်မှန်း",
  BS_ORZ: "ဖလားခန့်မှန်း",

  // LOT_BS: "အကြီး ၊ အသေး",
  // LOT_BIG: "အကြီး",
  // LOT_SMALL: "အသေး",
  // LOT_OE: "မ/စုံ",
  // LOT_ODD: "မ",
  // LOT_EVEN: "စုံ",
  // LOT_OU: "ဂိုးပေါ်/ဂိုးအောက်",
  // LOT_OVER: "ဂိုးပေါ်",
  // LOT_UNDER: "ဂိုးအောက်",
  // LOT_1: "အိမ်ရှင်",
  // LOT_0: "အဝေး",

  D_1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "ABC"
};